export default {
    yes: "Ano",
    no: "Ne"
}